import { Inject, Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LIB_CONFIG } from '../lib-config';
import { LibConfig } from '../models/lib-config.model';
import { v4 as uuidv4 } from 'uuid';
import { TokenService } from '../services/token.service';

@Injectable({
  providedIn: 'root',
})
export class HandshakeService {
  constructor(private tokenService: TokenService, @Inject(LIB_CONFIG) private config: LibConfig) {}

  getAuthorizationHeaders(): Observable<any> {
    return this.tokenService.getAuthToken().pipe(
      map((token: string) => {
        let headers = new HttpHeaders();
        headers = headers.set('Authorization', 'Bearer ' + token);
        headers = headers.set('Content-Type', 'application/json');
        const uuid = uuidv4();
        headers = headers.set('DAPI-AppID', this.config?.apigeeApi?.dapiAppId);
        headers = headers.set('DAPI-ClientSecret', this.config?.apigeeApi?.dapiClientSecret);
        headers = headers.set('DAPI-ChannelID', this.config?.apigeeApi?.dapiChannelId);
        headers = headers.set('DAPI-RequestID', uuid);
        headers = headers.set('DAPI-CorrelationID', uuid);
        headers = headers.set('DAPI-RequestTimestamp', new Date().toISOString());
        headers = headers.set('ZEUS-Location', window.location.pathname);
        return { headers };
      })
    );
  }
}
